import { jsx as _jsx } from "react/jsx-runtime";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import List from "components/Lists/List";
const { vendors: { GET_VENDORS, SEARCH_VENDORS } } = queries;
const { vendors: { DELETE_VENDOR } } = mutations;
const VendorsList = () => (_jsx(List, { deleteMutation: DELETE_VENDOR, hasSearch: true, itemNamePlural: "vendors", label: "Vendors", listQuery: GET_VENDORS, listQueryDataName: "getVendors", pathPrefix: "/vendors", searchQuery: SEARCH_VENDORS, searchQueryDataName: "searchVendors", searchQueryInputName: "searchVendorsInput", searchQueryPropertyName: "name" }));
export default VendorsList;
